var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1 16.8C1.5225 16.8 1.0283 16.5945 0.6174 16.1836C0.2065 15.7727 0.0007 15.2782 0 14.7V2.1C0 1.5225 0.2058 1.0283 0.6174 0.6174C1.029 0.2065 1.5232 0.0007 2.1 0H18.9C19.4775 0 19.972 0.2058 20.3836 0.6174C20.7952 1.029 21.0007 1.5232 21 2.1V14.7C21 15.2775 20.7945 15.772 20.3836 16.1836C19.9727 16.5952 19.4782 16.8007 18.9 16.8H2.1ZM10.5 9.45L18.9 4.2V2.1L10.5 7.35L2.1 2.1V4.2L10.5 9.45Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailAvatar);
export default __webpack_public_path__ + "static/media/mailAvatar.c0b340d554f89445720b38f5d17e3489.svg";
export { ForwardRef as ReactComponent };